export default __webpack_public_path__ + "static/media/wechat-155.5f83917c.jpeg";